import React from "react";
import { Outlet } from "react-router-dom";
import { useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import './DeliveryBoy.css';

const OutletLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  return (
    <div className="db-layout">
      <Header onToggleSidebar={toggleSidebar} />
      <div className="db-content-wrapper">
        <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <main className="db-main-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default OutletLayout;
